mutation PaymentDelete($input: PaymentDeleteInput!) {
  paymentDelete(input: $input) {
    deletedEntities {
      id
    }
  }
}
